// extracted by mini-css-extract-plugin
export var growableInput = "_42-0";
export var tagContainer = "_42-2";
export var textInput = "_42-1";